module.exports = __webpack_public_path__ + "static/media/logo-christmas.f886f6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-christmas.png
// module id = 66
// module chunks = 0